import { NodeNames } from '@farmersdog/constants';

export const VALID_NODE_NAMES = [
  NodeNames.Issues,
  NodeNames.PrescriptionDiets,
] as const;

export type ValidNodeName = (typeof VALID_NODE_NAMES)[number];
